document.addEventListener('DOMContentLoaded', function () {

  // Header — always visible, add scrolled class for subtle shadow
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('header--scrolled', window.scrollY > 50);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile menu
  var mobileNav = document.querySelector('[data-mobile-nav]');
  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var toggle = document.querySelector('[data-menu-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
    var toggle = document.querySelector('[data-menu-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  var menuToggle = document.querySelector('[data-menu-toggle]');
  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      if (mobileNav && mobileNav.classList.contains('is-open')) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    });
  }

  var menuClose = document.querySelector('[data-menu-close]');
  if (menuClose) {
    menuClose.addEventListener('click', closeMobileNav);
  }

  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMobileNav);
    });
  }

  // FAQ accordion
  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq__item');
      var wasOpen = item.classList.contains('is-open');
      item.closest('.faq__list').querySelectorAll('.faq__item').forEach(function (el) {
        el.classList.remove('is-open');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
      }
    });
  });

  // Smooth scroll for anchor links (supports both # and /#)
  document.querySelectorAll('a[href*="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      var hash = href.includes('#') ? '#' + href.split('#')[1] : null;
      if (!hash || hash === '#') return;
      var target = document.querySelector(hash);
      if (target) {
        e.preventDefault();
        closeMobileNav();
        var offset = header ? header.offsetHeight + 10 : 80;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  // Header dropdown menus (click to toggle)
  document.querySelectorAll('[data-nav-dropdown]').forEach(function (wrap) {
    var trigger = wrap.querySelector('[data-nav-trigger]');
    var menu = wrap.querySelector('.header__nav-menu');
    if (!trigger || !menu) return;
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = wrap.classList.contains('is-open');
      // close all others
      document.querySelectorAll('[data-nav-dropdown].is-open').forEach(function (other) {
        if (other !== wrap) {
          other.classList.remove('is-open');
          var m = other.querySelector('.header__nav-menu');
          if (m) m.hidden = true;
          var t = other.querySelector('[data-nav-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
      if (isOpen) {
        wrap.classList.remove('is-open');
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        wrap.classList.add('is-open');
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nav-dropdown]')) {
      document.querySelectorAll('[data-nav-dropdown].is-open').forEach(function (wrap) {
        wrap.classList.remove('is-open');
        var m = wrap.querySelector('.header__nav-menu');
        if (m) m.hidden = true;
        var t = wrap.querySelector('[data-nav-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Language switcher dropdown
  document.querySelectorAll('[data-lang-switcher]').forEach(function (wrap) {
    var btn = wrap.querySelector('[data-lang-toggle]');
    var menu = wrap.querySelector('.header__lang-menu');
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      menu.hidden = !menu.hidden;
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) menu.hidden = true;
    });
  });

  // Flip cards — click to flip, click X (or anywhere outside) to flip back
  document.querySelectorAll('[data-flip-card]').forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('[data-flip-close]')) {
        e.preventDefault();
        e.stopPropagation();
        card.classList.remove('is-flipped');
        return;
      }
      // Don't flip if clicking link on back side
      if (card.classList.contains('is-flipped') && e.target.closest('a')) return;
      if (!card.classList.contains('is-flipped')) {
        card.classList.add('is-flipped');
      }
    });
  });
  // Click outside any flipped card → flip back
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-flip-card]')) {
      document.querySelectorAll('[data-flip-card].is-flipped').forEach(function (c) {
        c.classList.remove('is-flipped');
      });
    }
  });

  // Offer: grid → accordion on card click
  document.querySelectorAll('[data-offer-grid]').forEach(function (grid) {
    var accordion = grid.parentElement.querySelector('[data-offer-accordion]');
    if (!accordion) return;
    var items = accordion.querySelectorAll('[data-offer-item]');

    var wrap = grid.closest('.offer-wrap');

    grid.querySelectorAll('[data-offer-trigger]').forEach(function (card) {
      card.addEventListener('click', function () {
        var idx = parseInt(card.getAttribute('data-offer-trigger'), 10);
        var gridH = grid.offsetHeight;
        var isMobile = window.innerWidth <= 768;
        items.forEach(function (i) { i.classList.remove('is-active'); });
        if (items[idx]) items[idx].classList.add('is-active');
        grid.classList.add('is-hidden');
        accordion.classList.remove('is-hidden');
        if (!isMobile) {
          accordion.style.height = gridH + 'px';
          accordion.style.minHeight = gridH + 'px';
        }
      });
    });

    // Click strip in accordion → switch active item
    items.forEach(function (item) {
      var strip = item.querySelector('[data-offer-strip]');
      if (strip) {
        strip.addEventListener('click', function () {
          items.forEach(function (i) { i.classList.remove('is-active'); });
          item.classList.add('is-active');
        });
      }
    });

    accordion.querySelectorAll('[data-offer-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        accordion.classList.add('is-hidden');
        accordion.style.height = '';
        accordion.style.minHeight = '';
        grid.classList.remove('is-hidden');
        items.forEach(function (i) { i.classList.remove('is-active'); });
      });
    });
  });

  // Scroll reveal animation
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll(
      '.feature-card, .coach-card, .product-card, .about__grid, .faq__item, .contact__item, .offer__card'
    ).forEach(function (el) {
      el.classList.add('reveal');
      observer.observe(el);
    });
  }

  // Fallback: make all reveal elements visible after 2s in case observer misses
  setTimeout(function () {
    document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }, 2000);
});
